import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./ClientsSection.css";

const token = localStorage.getItem("token");

const ClientsSection = () => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [clients, setClients] = useState([]);

  const handleScroll = (dir) => {
    scrollRef.current.scrollBy({
      left: dir === "right" ? 300 : -300,
      behavior: "smooth",
    });
  };

  // Fetch clients
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await axios.get("/client", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const nonDeleted = res.data.filter((c) => c.deletedAt === null);
        setClients(nonDeleted);
      } catch (error) {
        console.error("Erreur lors du chargement des clients:", error);
      }
    };

    fetchClients();
  }, []);

  return (
    <section className="clients-section">
      <h2 className="title">Nos clients</h2>
      <p className="subtitle">
        Nos prestations de services tournent principalement sur le développement
        des sites web et des applications mobiles.
      </p>

      <div className="clients-wrapper">
        {clients.length > 0 && (
          <button className="arrow-btn left" onClick={() => handleScroll("left")}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        )}

        <div className="clients-container" ref={scrollRef}>
          {clients.length > 0 ? (
            clients.map((client) => (
              <div className="client-card" key={client.id}>
                <img
                  src={client.photoUrl ? `/${client.photoUrl}` : '/photos/defaultProjectImage.png'}
                  alt={client.name}
                  className="client-img"
                  onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/photos/defaultProjectImage.png'; }}
                />
                <div className="client-info">
                  <h3>{client.name}</h3>
                  <p className="ptag">Description:</p>
                  <p className="ptag">{client.jobTitle}</p>
                  <p className="ptag">{client.email}</p>
                  <p className="proje-title">Projets:</p>
                  <ul>
                    {client.projects?.map((p, i) => (
                      <li key={i}>✔ {p.projectName}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))
          ) : (
            <p>Aucun client trouvé.</p>
          )}
        </div>

        {clients.length > 0 && (
          <button className="arrow-btn right" onClick={() => handleScroll("right")}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        )}
      </div>

      <div className="clients-btn">
        <button onClick={() => navigate("/admin/clients")}>
          Gérer les clients
        </button>
      </div>
    </section>
  );
};

export default ClientsSection;
